import script from "./DocumentTools.vue?vue&type=script&setup=true&lang=ts"
export * from "./DocumentTools.vue?vue&type=script&setup=true&lang=ts"

import "./DocumentTools.vue?vue&type=style&index=0&id=fd2ca21a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fd2ca21a"]])

export default __exports__